// TODO: this should redirect to a 404 page on the root site when available
const redirectTo404 = () => {
  if (window) {
    window.location.href = "https://global.bible";
  }
};

export default redirectTo404;
